import './VideoCard.css'
import { useRef, useState, useEffect } from "react";
import { FaPlay, FaExpand } from "react-icons/fa";

export default function VideoCard({ videoUrl, name, onPlayStateChange, videoId }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // Handle video ended event
  useEffect(() => {
    const handleEnded = () => {
      setIsPlaying(false);
      if (onPlayStateChange) {
        onPlayStateChange(false, videoId);
      }
    };

    if (videoRef.current) {
      videoRef.current.addEventListener('ended', handleEnded);
      return () => {
        videoRef.current?.removeEventListener('ended', handleEnded);
      };
    }
  }, [onPlayStateChange, videoId]);

  const handlePlay = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
      if (onPlayStateChange) {
        onPlayStateChange(false, videoId);
      }
    } else {
      // Pause all other videos
      if (onPlayStateChange) {
        onPlayStateChange(true, videoId);
      }
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleFullscreen = () => {
    if (!videoRef.current) return;

    if (videoRef.current.requestFullscreen) {
      videoRef.current.requestFullscreen();
    }
  };

  return (
    <div className="video-card">
      <div className="video-wrapper">
        <video
          ref={videoRef}
          src={videoUrl}
          className="video-element"
          onClick={handlePlay}
          data-video-id={videoId}
        />

        {!isPlaying && (
          <button className="play-button" onClick={handlePlay}>
            <FaPlay />
          </button>
        )}

        <button className="fullscreen-button" onClick={handleFullscreen}>
          <FaExpand />
        </button>
      </div>

      <h4 className="video-title">{name}</h4>
    </div>
  );
}

